import {
  Form,
  TreeSelect,
} from 'antd'
import React from 'react'

import EmployeeSelect from '@/components/fields/employee-select'
import { GroupType } from '@/model/group'
import { selectGroupTreeData } from '@/redux/group-selectors'
import { useAppSelector } from '@/redux/utils'

export function EmployeesFilterFields() {
  const groupOptions = useAppSelector(state => selectGroupTreeData(state, GroupType.Employee))

  return (
    <>
      <Form.Item name="employeeIds" label={'Filter by employee(s)'}>
        <EmployeeSelect />
      </Form.Item>
      <Form.Item name="groupIds" label={'Filter by group(s)'}>
        <TreeSelect<number>
          treeData={groupOptions}
          treeDefaultExpandAll
          allowClear
          placeholder="Select group"
          multiple
        />
      </Form.Item>
    </>
  )
}
